import { SensorModel } from "projects/phdsoft/common/src/lib/models/sensor.model";

export class SensorPropertiesMapper {
  public static MapToVisualizationMode(data: SensorModel) {
    return {
      sensorId: data.id,
      name: data.label,
      sensorTypeName: data.sensorTypeName,
      deviceName: data.deviceName,
      assetName: data.assetName,
      regionName: data.regionName,
      sectionName: data.sectionName,
      description: data.description,
      calibrationConst: data.calibrationConst,
      offsetValue: data.offsetValue,
      photos: data.photos,
      installationDate: data.installationDate,
      lastCalibrationDate: data.lastCalibrationDate,
    }
  }
}
